module.exports = __webpack_public_path__ + "img/gallery-events-cover.63486211.png";